import type { ResponseWithError } from '@rango-dev/internal-profile/api';
import type { AxiosError, AxiosResponse } from 'axios';

import { initializeFetcher } from '@rango-dev/internal-profile';
import { BASE_PROFILE_URL, UserUnauthorizedError } from '@rango-dev/internal-profile/api';
import axios from 'axios';

import { API_KEY, BASE_URL } from '../utils/Constants';

declare module 'axios' {
  interface AxiosRequestConfig {
    /**
     * When true, the response interceptor won't throw on a truthy `data.error`, letting the caller
     * handle the error envelope in-band (e.g. reading `errorCode`).
     */
    skipResponseErrorInterceptor?: boolean;
  }
}

const UNAUTHORIZED_STATUS_CODE = 401;

let handleLogout: () => void;

export function initializeLogoutHandler(handler: typeof handleLogout) {
  handleLogout = handler;
}

export const httpService = axios.create({ baseURL: BASE_URL, params: { apiKey: API_KEY } });

httpService.interceptors.response.use(
  (response: AxiosResponse<ResponseWithError>) => {
    if (response.data.error && !response.config.skipResponseErrorInterceptor) {
      throw new Error(response.data.error);
    }
    return response;
  },
  async (error: AxiosError) => {
    if (
      error.config?.url?.includes(BASE_PROFILE_URL) &&
      error.response?.status === UNAUTHORIZED_STATUS_CODE
    ) {
      handleLogout?.();
      return Promise.reject(new UserUnauthorizedError());
    }
    return Promise.reject(error);
  },
);

initializeFetcher(httpService);
